define("shared/utils/array-filters/extract-values-over-time", ["exports", "@ember/utils"], function (_exports, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.extractValuesOverTime = _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/utils"eaimeta@70e063a35619d71f
  /**
   * For each object in the array, extracts out the given time and value keys
   *
   * @param data
   * @param valueKey Name of value key for data
   * @param timeKey Name of time key for data
   *
   * @returns Returns only data properties that match time and value keys
   */
  const extractValuesOverTime = (data, valueKey, timeKey) => {
    if (!data) {
      return null;
    }
    const result = data.map(point => ({
      time: (0, _utils.isPresent)(point[timeKey]) ? Number(point[timeKey]) : point[timeKey],
      value: (0, _utils.isPresent)(point[valueKey]) ? Number(point[valueKey]) : point[valueKey]
    }));
    return result;
  };
  _exports.extractValuesOverTime = extractValuesOverTime;
  var _default = _exports.default = extractValuesOverTime;
});